'use client';

import { Skeleton } from '@/components/atoms/Skeleton';
import useBreakpoint, { breakpointDesktopDefault } from '@/hooks/useBreakpoint';
import { recuperarTermos } from '@/services/autenticacaoService';
import { theme } from '@/styles/theme';
import formatarHTML from '@/utils/formatarHTML';
// import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import * as S from './styles';
import useMetodosUteis, {
  HTMLHigienizadoTag,
} from '@/hooks/useMetodosUteisHook';

export type TipoTermos = 'termosDeServico' | 'politicaPrivacidade';

export type TermosPageProps = {
  $tipoTermo: TipoTermos | undefined;
};

export default function Termos(props: TermosPageProps) {
  const { $tipoTermo } = props;
  const { breakpoint } = useBreakpoint();
  const [termo, setTermo] = useState<string | null>(null);

  async function recuperarTermosChippu(tipoTermoBusca: TipoTermos) {
    const termoFromServer = await recuperarTermos(tipoTermoBusca);
    setTermo(termoFromServer.politica);
  }

  useEffect(() => {
    const termoHTMLSession = sessionStorage.getItem('termoHTML');

    if (!termoHTMLSession) {
      recuperarTermosChippu($tipoTermo ?? 'termosDeServico');
    } else {
      setTermo(termoHTMLSession);
    }
  }, [$tipoTermo]);

  // const router = useRouter();

  const { higienizarHTML } = useMetodosUteis();

  const breakpointDesktopStyle =
    breakpoint === 'mobile'
      ? {}
      : { ...breakpointDesktopDefault, maxWidth: 900 };

  return (
    <S.Container style={breakpointDesktopStyle}>
      {!termo ? (
        <Skeleton style={{ height: '80vh' }} />
      ) : (
        <S.ContainerTexto $breakpoint={breakpoint}>
          <S.ContainerHTML>
            <HTMLHigienizadoTag
              html={higienizarHTML(
                formatarHTML(
                  termo.replace(
                    'color:#48D9D3',
                    `color:${theme.colors.neutral.neutral_alpha[11]}`,
                  ),
                ),
              )}
            />
          </S.ContainerHTML>
        </S.ContainerTexto>
      )}
    </S.Container>
  );
}
